(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tdp-contact-assist"] && !Shopify.designMode) return;
  try {
    (() => {const init=()=>document.querySelectorAll('[data-tdp-assist]').forEach(box=>{if(box.dataset.bound)return;box.dataset.bound='true';const select=box.querySelector('[data-help-topic]');select.addEventListener('change',()=>{box.querySelectorAll('[data-help-answer]').forEach(answer=>{answer.hidden=answer.dataset.helpAnswer!==select.selectedOptions[0].dataset.topic;});});});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tdp-finder"] && !Shopify.designMode) return;
  try {
    function initTdpFinder(scope) {
 scope.querySelectorAll('[data-tdp-finder]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-finder-form]');
  const result = root.querySelector('[data-finder-result]');
  const map = {tee: ['chandail-tropdepoutine','le-lifestyle'], warm: ['le-crewneck-poutine','le-hoodie-poutine'], accessory: ['la-cap','bas-soccer']};
  form.addEventListener('submit', event => {
   event.preventDefault();
   if (!form.reportValidity()) return;
   const values = new FormData(form);
   const handle = map[values.get('piece')]?.[values.get('mood') === 'classic' ? 0 : 1];
   if (!handle) return;
   root.querySelectorAll('[data-finder-product]').forEach(card => {card.hidden = card.dataset.finderProduct !== handle;});
   result.hidden = false; result.focus(); result.scrollIntoView({block:'start',behavior:'auto'});
  });
  root.querySelector('[data-finder-reset]').addEventListener('click', () => {
   form.reset(); result.hidden = true; form.querySelector('input').focus();
  });
 });
}
initTdpFinder(document);
document.addEventListener('shopify:section:load', event => initTdpFinder(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tdp-product-save"] && !Shopify.designMode) return;
  try {
    (() => {
 const init=()=>document.querySelectorAll('[data-tdp-save]').forEach(box=>{
  if(box.dataset.bound)return;box.dataset.bound='true';const status=box.querySelector('[data-save-status]'),fallback=box.querySelector('[data-save-fallback]');
  const link=()=>{const url=new URL(decodeURIComponent(box.dataset.path),decodeURIComponent(box.dataset.domain));const variant=document.querySelector('form[data-cart-form] [name="id"]')?.value;if(variant)url.searchParams.set('variant',variant);return url.href;};
  box.querySelector('[data-save-pin]').addEventListener('click',event=>{const pin=new URL(event.currentTarget.href);pin.searchParams.set('url',link());const visibleImage=document.querySelector('.product__photo--variant-wrapper:not(.hide) img');if(visibleImage?.currentSrc)pin.searchParams.set('media',visibleImage.currentSrc);event.currentTarget.href=pin.href;});
  box.querySelector('[data-copy-product]').addEventListener('click',async()=>{const url=link();try{await navigator.clipboard.writeText(url);status.textContent=box.dataset.copied;fallback.hidden=true;}catch(error){status.textContent=box.dataset.error;fallback.hidden=false;fallback.value=url;fallback.focus();fallback.select();}});
 });if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tdp-shipping-estimator"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => document.querySelectorAll('[data-tdp-rate]').forEach(box => {
  if(box.dataset.readyBound)return;box.dataset.readyBound='true';
  const country=box.querySelector('[data-rate-country]'),province=box.querySelector('[data-rate-province]'),postal=box.querySelector('[data-rate-postal]'),button=box.querySelector('[data-rate-button]'),output=box.querySelector('[data-rate-results]');
  const quantities=Array.from(box.closest('form').querySelectorAll('input[name="updates[]"]')).map(el=>[el,el.value]);
  let request=0,controller;
  const clear=()=>{request++;controller?.abort();button.disabled=false;output.replaceChildren();};
  const regions=()=>{const list=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');province.replaceChildren(...(list.length?[new Option(box.dataset.choose,'')]:[]),...list.map(([value,label])=>new Option(label,value)));box.querySelector('[data-rate-region]').hidden=!list.length;clear();};
  const preferred=Array.from(country.options).find(o=>o.value===box.dataset.defaultCountry||o.textContent===box.dataset.defaultCountry);
  if(preferred)country.value=preferred.value;else if(Array.from(country.options).some(o=>o.value==='Canada'))country.value='Canada';
  regions();country.addEventListener('change',regions);province.addEventListener('change',clear);postal.addEventListener('input',clear);quantities.forEach(([el])=>el.addEventListener('input',clear));window.addEventListener('pageshow',event=>{if(event.persisted)clear();});
  button.addEventListener('click',async()=>{
   clear();const attempt=request;
   if(quantities.some(([el,value])=>el.value!==value)){output.textContent=box.dataset.changed;return;}
   if(!country.value||country.value==='---'||(!box.querySelector('[data-rate-region]').hidden&&!province.value)||!postal.value.trim()){output.textContent=box.dataset.invalid;postal.focus();return;}
   button.disabled=true;output.textContent=box.dataset.loading;controller=new AbortController();const signal=controller.signal;
   const timeout=setTimeout(()=>controller.abort(),20000);
   const params=new URLSearchParams({'shipping_address[country]':country.value,'shipping_address[province]':province.value,'shipping_address[zip]':postal.value.trim()});
   const base=box.dataset.root.replace(/\/?$/,'/');
   try {
    const started=await fetch(base+'cart/prepare_shipping_rates.json?'+params,{method:'POST',credentials:'same-origin',signal});if(!started.ok)throw Error('rates');
    let data=null;
    for(let i=0;i<12;i++){
     if(attempt!==request)return;
     const response=await fetch(base+'cart/async_shipping_rates.json?'+params,{credentials:'same-origin',cache:'no-store',signal});if(!response.ok)throw Error('rates');
     const body=await response.text();data=body?JSON.parse(body):null;if(data?.shipping_rates)break;
     await new Promise(resolve=>setTimeout(resolve,1000));
    }
    if(attempt!==request)return;if(!data?.shipping_rates)throw Error('rates');output.replaceChildren();
    const heading=document.createElement('p');heading.textContent=data.shipping_rates.length?box.dataset.ready:box.dataset.none;output.append(heading);
    const list=document.createElement('ul');
    data.shipping_rates.forEach(rate=>{const amount=Number(rate.price);if(!Number.isFinite(amount))return;const li=document.createElement('li');li.textContent=(rate.presentment_name||rate.name)+' — '+new Intl.NumberFormat(box.dataset.locale,{style:'currency',currency:rate.currency||box.dataset.currency,currencyDisplay:'code'}).format(amount);list.append(li);});output.append(list);
   }catch(error){if(attempt===request)output.textContent=box.dataset.error;}finally{clearTimeout(timeout);if(attempt===request)button.disabled=false;}
  });
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
